import { render } from "./Applications.vue?vue&type=template&id=773da3e2&scoped=true&ts=true"
import script from "./Applications.vue?vue&type=script&lang=ts"
export * from "./Applications.vue?vue&type=script&lang=ts"

import "./Applications.vue?vue&type=style&index=0&id=773da3e2&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773da3e2"]])

export default __exports__